import React from 'react';

import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';

import { UNV, VER } from '../../enums/address-verification-status';
import { NotValidated } from './components/not-validated';
import { Validated } from './components/validated';
import { ValidationIssue } from './components/validation-issue';
import { ValidationErrorEmptyAddress } from './components/validation-error-empty-address';

export const AddressValidationStatus = ({
  validation,
  validationMessage = '',
  residentialIndicator = '',
  validateAddress = noop,
  countryCode = '',
  hideValidateButton = false,
  className = '',
  validationIssueMessageClassName,
  shouldTruncateValidationIssue = true,
  isEmptyAddress = false,
}) => {
  if (isEmptyAddress) {
    return <ValidationErrorEmptyAddress className={className} />;
  }

  if (!validation || validation === UNV) {
    return !hideValidateButton && <NotValidated validateAddress={validateAddress} />;
  }

  if (validation === VER) {
    return <Validated className={className} countryCode={countryCode} residentialIndicator={residentialIndicator} />;
  }

  return (
    <ValidationIssue
      className={className}
      shouldTruncateText={shouldTruncateValidationIssue}
      validation={validation}
      validationMessage={validationMessage}
      validationMessageClassName={validationIssueMessageClassName}
    />
  );
};

AddressValidationStatus.propTypes = {
  validation: PropTypes.string,
  validationMessage: PropTypes.string,
  residentialIndicator: PropTypes.string,
  countryCode: PropTypes.string,
  validateAddress: PropTypes.func,
  hideValidateButton: PropTypes.bool,
  className: PropTypes.string,
  validationIssueMessageClassName: PropTypes.string,
  shouldTruncateValidationIssue: PropTypes.bool,
  isEmptyAddress: PropTypes.bool,
};
